import { CatalogFilterBlueprint } from '@backstage/plugin-catalog-react/alpha';

// PAT-1027: PAT-422's user-identity annotation facets on `/catalog`, next to
// the alpha plugin's eight default filters. A module's extensions come after
// the plugin's own, so they render after the defaults, as `<DefaultFilters />`
// followed by these four did on the legacy page. Each picker hides itself when
// no entity in scope carries its annotation, so they only show for kind=user.
export const userAnnotationFilters = [
  CatalogFilterBlueprint.make({
    name: 'user-role',
    params: {
      loader: () =>
        import('../../components/catalog/filters/UserAnnotationPickers').then(
          m => <m.EntityUserRolePicker />,
        ),
    },
  }),
  CatalogFilterBlueprint.make({
    name: 'user-department',
    params: {
      loader: () =>
        import('../../components/catalog/filters/UserAnnotationPickers').then(
          m => <m.EntityUserDepartmentPicker />,
        ),
    },
  }),
  CatalogFilterBlueprint.make({
    name: 'user-office',
    params: {
      loader: () =>
        import('../../components/catalog/filters/UserAnnotationPickers').then(
          m => <m.EntityUserOfficePicker />,
        ),
    },
  }),
  CatalogFilterBlueprint.make({
    name: 'user-country',
    params: {
      loader: () =>
        import('../../components/catalog/filters/UserAnnotationPickers').then(
          m => <m.EntityUserCountryPicker />,
        ),
    },
  }),
];
